if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // チケットフィールドのバリデーション
        if (!this.validateTicketFields()) {
          return;
        }

        // チケット情報を注文メモに追加
        this.addTicketDataToOrderNote();

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        // フォームデータを処理
        for (let [key, value] of formData.entries()) {
          // フォームデータの処理
        }
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      validateTicketFields() {
        // チケット情報入力フィールドの必須項目をチェック
        // フォーム内外両方を検索
        let ticketFields = this.form.querySelector('.product__ticket-fields');
        if (!ticketFields) {
          ticketFields = document.querySelector('.product__ticket-fields');
        }
        
        let isValid = true;
        let firstInvalidField = null;

        // 既存のエラー表示をクリア
        this.clearTicketFieldErrors();

        // 同意チェックボックスの特別なバリデーション（フォーム内外問わず検索）
        const agreementField = document.querySelector('.ticket-field--agreement');
        if (agreementField) {
          const agreementCheckbox = agreementField.querySelector('input[type="checkbox"]');
          if (agreementCheckbox && agreementCheckbox.hasAttribute('required') && !agreementCheckbox.checked) {
            isValid = false;
            this.showTicketFieldError(agreementCheckbox, '同意が必要です');
            if (!firstInvalidField) {
              firstInvalidField = agreementCheckbox;
            }
          }
        }

        // チケットフィールドがない場合は同意チェックボックスのバリデーション結果を返す
        if (!ticketFields) return isValid;

        // 代わりに、カスタムバリデーションロジックを実装
        const fieldGroups = ticketFields.querySelectorAll('.ticket-field:not(.ticket-field--agreement)');
        
        fieldGroups.forEach(fieldGroup => {
          // data-required 属性で必須フィールドを判定（より確実）
          const isRequired = fieldGroup.hasAttribute('data-required');
          
          if (!isRequired) return;
          
          let value = '';
          let fieldForFocus = null;
          
          // フィールドタイプを判定して値を取得
          const textInput = fieldGroup.querySelector('input[type="text"], input[type="email"], textarea, select');
          const radioGroup = fieldGroup.querySelector('.field__input--radio-group');
          const checkboxGroup = fieldGroup.querySelector('.field__input--checkbox-group');
          
          if (textInput) {
            // テキスト、メール、テキストエリア、セレクト
            value = textInput.value.trim();
            fieldForFocus = textInput;
            
            // メールアドレスの形式チェック
            if (textInput.type === 'email' && value && !this.isValidEmail(value)) {
              isValid = false;
              this.showTicketFieldError(textInput, 'メールアドレスの形式が正しくありません');
              if (!firstInvalidField) {
                firstInvalidField = textInput;
              }
              return;
            }
          } else if (radioGroup) {
            // ラジオボタングループ
            const selectedRadio = radioGroup.querySelector('input[type="radio"]:checked');
            value = selectedRadio ? selectedRadio.value : '';
            fieldForFocus = radioGroup.querySelector('input[type="radio"]');
          } else if (checkboxGroup) {
            // チェックボックスグループ
            const checkedBoxes = checkboxGroup.querySelectorAll('input[type="checkbox"]:checked');
            value = checkedBoxes.length > 0 ? Array.from(checkedBoxes).map(cb => cb.value).join(', ') : '';
            fieldForFocus = checkboxGroup.querySelector('input[type="checkbox"]');
          }
          
          if (!value) {
            isValid = false;
            if (fieldForFocus) {
              this.showTicketFieldError(fieldForFocus);
              if (!firstInvalidField) {
                firstInvalidField = fieldForFocus;
              }
            }
          }
        });

        if (!isValid) {
          // エラーメッセージを表示
          this.handleErrorMessage('必須項目をすべて入力してください');
          
          // 最初のエラーフィールドにフォーカス
          if (firstInvalidField) {
            firstInvalidField.focus();
            firstInvalidField.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }

        return isValid;
      }

      clearTicketFieldErrors() {
        // フォーム内のチケットフィールドのエラーをクリア
        const ticketFields = this.form.querySelector('.product__ticket-fields');
        if (ticketFields) {
          // エラークラスを削除
          ticketFields.querySelectorAll('.field--error').forEach(field => {
            field.classList.remove('field--error');
          });

          // エラーメッセージを削除
          ticketFields.querySelectorAll('.field__error-message').forEach(error => {
            error.remove();
          });
        }

        // フォーム外の同意チェックボックスのエラーもクリア
        const agreementField = document.querySelector('.ticket-field--agreement');
        if (agreementField) {
          agreementField.classList.remove('field--error');
          const errorMessage = agreementField.querySelector('.field__error-message');
          if (errorMessage) {
            errorMessage.remove();
          }
        }
      }

      showTicketFieldError(field, message = null) {
        const fieldWrapper = field.closest('.ticket-field');
        if (!fieldWrapper) return;

        // エラークラスを追加
        fieldWrapper.classList.add('field--error');

        // エラーメッセージを表示
        if (!fieldWrapper.querySelector('.field__error-message')) {
          const errorMessage = document.createElement('span');
          errorMessage.className = 'field__error-message';
          errorMessage.textContent = message || 'この項目は必須です';
          
          // ラベルの直後に挿入
          const label = fieldWrapper.querySelector('.field__label');
          if (label) {
            label.parentNode.insertBefore(errorMessage, label.nextSibling);
          } else {
            // ラベルがない場合は先頭に追加
            fieldWrapper.insertBefore(errorMessage, fieldWrapper.firstChild);
          }
        }
      }

      isValidEmail(email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
      }

      addTicketDataToOrderNote() {
        // フォーム内からチケットフィールドを探す
        let ticketFields = this.form.querySelector('.product__ticket-fields');
        
        // フォーム内に見つからない場合は、ページ全体から探す
        if (!ticketFields) {
          ticketFields = document.querySelector('.product__ticket-fields');
        }
        
        if (!ticketFields) return;

        const ticketData = this.collectTicketData(ticketFields);
        
        if (ticketData.length > 0) {
          this.addToOrderNote(ticketData);
        }
      }

      collectTicketData(ticketFields) {
        const data = [];
        const fieldGroups = ticketFields.querySelectorAll('.ticket-field');
        
        fieldGroups.forEach((fieldGroup) => {
          // 同意チェックボックスの場合は特別な処理
          if (fieldGroup.classList.contains('ticket-field--agreement')) {
            const agreementCheckbox = fieldGroup.querySelector('input[type="checkbox"]');
            if (agreementCheckbox && agreementCheckbox.checked) {
              const agreementLabel = fieldGroup.querySelector('.checkbox-label');
              let labelText = '同意確認';
              if (agreementLabel) {
                // 余分なスペースと記号を削除
                labelText = agreementLabel.textContent
                  .replace(/\s*\*\s*/g, '') // *とその前後のスペースを削除
                  .replace(/\s+/g, ' ')     // 複数のスペースを1つにまとめる
                  .trim();                  // 前後のスペースを削除
              }
              data.push({
                label: labelText,
                value: '同意しました'
              });
            }
            return;
          }
          
          const label = fieldGroup.querySelector('.field__label');
          let labelText = '';
          if (label) {
            // 余分なスペースと記号を削除
            labelText = label.textContent
              .replace(/\s*\*\s*/g, '')   // *とその前後のスペースを削除
              .replace(/\s+/g, ' ')       // 複数のスペースを1つにまとめる
              .trim();                    // 前後のスペースを削除
          }
          
          if (!labelText) return;
          
          let value = '';
          
          // フィールドタイプを判定して値を取得
          const textInput = fieldGroup.querySelector('input[type="text"], input[type="email"], textarea, select');
          const radioGroup = fieldGroup.querySelector('.field__input--radio-group');
          const checkboxGroup = fieldGroup.querySelector('.field__input--checkbox-group');
          
          if (textInput) {
            value = textInput.value.trim();
          } else if (radioGroup) {
            const selectedRadio = radioGroup.querySelector('input[type="radio"]:checked');
            value = selectedRadio ? selectedRadio.value : '';
          } else if (checkboxGroup) {
            const checkedBoxes = checkboxGroup.querySelectorAll('input[type="checkbox"]:checked');
            value = checkedBoxes.length > 0 ? Array.from(checkedBoxes).map(cb => cb.value).join(', ') : '';
          }
          
          if (value) {
            data.push({
              label: labelText,
              value: this.sanitizeForNote(value)
            });
          }
        });
        
        return data;
      }

      sanitizeForNote(value) {
        return value
          .replace(/\r\n/g, '\n')     // Windows改行を統一
          .replace(/\r/g, '\n')       // Mac改行を統一
          .replace(/\n{3,}/g, '\n\n') // 3つ以上の連続改行を2つに制限
          .trim();
      }

      addToOrderNote(ticketData) {
        // 注文メモフィールドを探すか作成
        let noteField = this.form.querySelector('textarea[name="note"]');
        if (!noteField) {
          noteField = document.createElement('textarea');
          noteField.name = 'note';
          noteField.style.display = 'none';
          this.form.appendChild(noteField);
        }

        // 既存のメモがある場合は改行で区切る
        const existingNote = noteField.value.trim();
        const ticketNote = this.formatTicketNote(ticketData);
        
        if (existingNote) {
          noteField.value = existingNote + '\n\n' + ticketNote;
        } else {
          noteField.value = ticketNote;
        }
        

      }

      formatTicketNote(ticketData) {
        const lines = [];
        
        // ヘッダー（タイムスタンプ付き）
        const now = new Date();
        const timestamp = now.toLocaleString('ja-JP', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
        
        lines.push('───────────────────');
        lines.push('🎫 チケット情報');
        lines.push(`📅 登録日時: ${timestamp}`);
        lines.push('───────────────────');
        lines.push('');
        
        // 各項目を追加
        ticketData.forEach((item, index) => {
          lines.push(`${index + 1}. ${item.label}`);
          
          // 値が複数行の場合はインデントを付ける
          const valueLines = item.value.split('\n');
          if (valueLines.length === 1) {
            lines.push(`   ${item.value}`);
          } else {
            valueLines.forEach(line => {
              lines.push(`   ${line}`);
            });
          }
          
          // 項目間の区切り
          if (index < ticketData.length - 1) {
            lines.push('');
          }
        });
        
        // フッター
        lines.push('');
        lines.push('───────────────────');
        
        return lines.join('\n');
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
